import React, { useState } from "react";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import logo from "../../../assets/images/logo.png";

const PdfGenerator = () => {


    const [trfDetails, setTrfDetails] = useState(
        {
        trfId:"16938",
        companyName: "Zhejiang Yicai Printing &Dyeing Co.,ltd",
      companyAddress: "Shaoxing ,China ",
    referenceCourierId: "1523283953196",
    invoiceNumber: "FY3826",
    birlaFibre: "Livaeco Viscose/ Rayon by Birla Cellulose",
    fabricOrderNumber: "133409240/133409241/133409242/133409243/133409244/133409245/133409248/133409249/133409250",
    brandName: "Others",
    sampleBatchNumber: null,
    garmenterName: "Others",
    finishedFabricManufacturerName: "Zhejiang Yicai Printing &Dyeing Co.,ltd",
    greigeFabricManufacturerName: "Others",
    spinnerName: "Others",
    claimedComposition: "85",
    warpWeft: "12*12",
    fabricGsm: "185",
    courierId: "11122023/6773",
    isShortlisted: 1,
    remarks: null,
    isDeleted: 0,
    isSubmitted: 1,
    isVerified: 0,
    companyKeyId: 1672,
    createdDate: "2023-12-11T08:35:35.000Z",
    createdBy: 1544,
    modifiedDate: "2023-12-11T08:35:53.000Z",
    modifiedBy: 733,
    testedDate: "2024-03-08T03:42:37.014Z",
    testReferenceNumber: "China/080324/16561",
    productionDate: "2023-11-13T18:30:00.000Z",
    productDetails: null,
    notifyUsersEmail: "elainefengyi@163.com ",
    tracerRegion: "China",
    testedBy: "733",
    otherBrandName: "ASOS",
    otherGarmenterName: "INDOCHINE CAMBODIA APPAREL LTD ",
    otherFinishedFabricManufacturerName: null,
    otherGreigeFabricManufacturerName: "Anhui Yuhua Textile Limited Company ",
    otherSpinnerName: "Anhui Yuhua Texitle Limited Company ",
    notVerifiedReasonText: "guu",
    warpWeftBlend: "Birla fibre is : 85, Linen : 15",
    warpWeftWidth: "51",
    warpWeftConstruction: "56*41",
    yarnType: null,
    fromDate: null,
    productTypeName: "Finished Fabric",
    tracerDocument: {}
})


    
  const generatePdf = async () => { 
    // Convert image to base64
    //  const reader = new FileReader();
    //  reader.readAsDataURL(logo);
    //  reader.onloadend = () => {
    //    const imageLogo = reader.result;
    //  }
    try {
      const response = await fetch(logo);
      const blob = await response.blob();
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        const base64data = reader.result;
        const documentDefinition = {
          content: [
            { 
                image: base64data, // Use the base64 string here
                width: 250,
                alignment: 'center',
                margin: [0, 0, 0, 20]
              },
            {
              style: "tableExample",
              table: {
                widths: ["*", "*"],
                body: [
                  [
                    {
                      text: `Invoice Number: ${trfDetails.trfId} `,
                      style: "invoiceNumber",
                    },
                    {
                      text: "TRANSACTION CERTIFICATE NUMBER\nFF -18/05/2022-57902",
                      style: "transactionNumber",
                    },
                  ],
                  [
                    {
                      text: "Supplier's Name:\nFFM India Ltd",
                      style: "sectionHeader",
                    },
                    {
                      text: "Buyer's Name:\nGarment India Ltd",
                      style: "sectionHeader",
                    },
                  ],
                ],
              },
              layout: "noBorders",
            },
            {
              text: "Shipment Description:\nNot Defined",
              margin: [0, 10, 0, 10],
            },
            {
              text: "Product Description:\nStaple Fibre Bright Bleached Grasi Silk 0.8 d 64 mm",
              margin: [0, 0, 0, 10],
            },
            {
              text: "Products:\n30's Liva Eco Ring x 30's Liva Eco Vortex / 84 x 64 - 54\" - Plain Weave",
              margin: [0, 0, 0, 10],
            },
            { text: "Quantity:\n20 kg", margin: [0, 0, 0, 20] },
            {
              text: 'The blockchain-enabled "Chain of Custody" (CoC) platform - GreenTrack confirms that the aforementioned products made using below Fibre (s) * and the material flow from forest till current stage has been mapped and verified for traceability throughout the supply chain',
              style: "footerText",
            },
            {
              text: "Fibre:\nStaple Fibre Bright Bleached Grasi Silk 0.8 d 64 mm",
              style: "footerText",
              margin: [0, 10, 0, 0],
            },
            {
              text: "This document has been generated from GreenTrackTM - a Blockchain traceability solution by Birla Cellulose",
              style: "disclaimer",
            },
            {
                text: 'Additional Content Here',
                pageBreak: 'before', // This will start the content on a new page
              },
              // More content...
    
          ],
          footer: function(currentPage, pageCount) {
            return {
              margin: 10,
              columns: [
                { text: 'This is a dynamically generated document.', alignment: 'left', fontSize: 8, italics: true },
                { text: `Page ${currentPage} of ${pageCount}`, alignment: 'right', fontSize: 8, italics: true }
              ]
            };
          },
          styles: {
            tableExample: {
              margin: [0, 5, 0, 15],
            //   background: '#F6F8FC'
            },
            invoiceNumber: {
              fontSize: 10,
              margin: [0, 5, 0, 5],
            },
            transactionNumber: {
              fontSize: 10,
              color: "green",
              bold: true,
              alignment: "right",
              margin: [0, 5, 0, 5],
            },
            sectionHeader: {
              fontSize: 12,
              bold: true,
              margin: [0, 5, 0, 5],
              fillColor: "#eeeeee",
            },
            footerText: {
              fontSize: 9,
              italics: true,
              margin: [0, 10, 0, 0],
            },
            disclaimer: {
              fontSize: 8,
              italics: true,
              color: "grey",
              margin: [0, 5, 0, 0],
            },
          },
          defaultStyle: {
            columnGap: 20,
          },
        };
        pdfMake.createPdf(documentDefinition).download("pdf-document.pdf");
      };
    } catch (error) {
      console.error("Error converting image to Base64", error);
    }
  };

  return (
    <div>
      <button onClick={generatePdf}>Generate PDF</button>
    </div>
  );
};

export default PdfGenerator;